import React from 'react';
import { useParams } from 'react-router-dom';

import styles from '../css/citations.module.css';
import { AggregatorData } from '../models/aggregatorData';
import { PageInit } from './AppState';
import Layout from './Layout';
import ReferencesTable from './ReferencesTable';
import mockData from '../resources/mockData.json';
import {AppStateInstance} from "./AppState/AppStateContext";
import {waitUntilDefined} from "./util/UtilityFunctions";



const LoadingContainer = () => {
  return (
    <div>Loading...</div>
  )
}
const ReferencesContainer = ({analysis}: { analysis: AggregatorData }) => {
  return (
    <React.Fragment>
      <ReferencesTable references={analysis.references} title={analysis.title} authors={analysis.authors} />
    </React.Fragment>
  )
}

const AnalysisContainer = () => {

  const [analysis, setAnalysis] = React.useState<AggregatorData | undefined>(undefined);
  const [aaInitComplete, setAAInitComplete] = React.useState<boolean>(false)

  const [isLoading, setIsLoading] = React.useState(false);
  const appState = React.useContext(AppStateInstance);

  let { id } = useParams();

  React.useEffect(() => {
    const abortController = new AbortController();
    setIsLoading(true);
    if (id === "_mock") {
      // @ts-ignore
      setAnalysis(mockData);
      setIsLoading(false);
    } else if (analysis === undefined) {
      fetch("/aggregator-service/analysisReport/" + id, {
        credentials: "include",
        signal: abortController.signal
      })
        .then(r => r.json())
        .then(r => {
          setAnalysis(r)
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(()=>{
    if(!aaInitComplete && analysis !== undefined){
      waitUntilDefined(()=>{return window.pageDataTracker})
        .then(()=>{return waitUntilDefined(()=>{return appState.globalState.aaBusinessUnit})})
        .then(()=>appState.analyticsDispatcher(
          PageInit({
            journalCode: analysis.journalCode,
            journal: analysis.journal,
            documentId: analysis.documentId,
            revision: analysis.revision,
            resultsPerPage: 0,
            title: analysis.title,
          },
            appState.globalState)))
        .then(() => setAAInitComplete(true));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appState.globalState, analysis])

  let container;

  if (isLoading) {
    container = <LoadingContainer />;
  } else if (analysis !== undefined) {
    container = <ReferencesContainer analysis={analysis}/>;
  }
  else {
    container = <></>
  }
  return (
    <Layout>
      <div className={`${styles.analysisContainer}`}>
        {container}
      </div>
    </Layout>
  )
}


export default AnalysisContainer;
